import { Schema$UserPickMatch } from '@interface/user-pick'
import { Schema$MatchTrack, Schema$TournamentTrack } from '@protocol/game'
import { Schema$CheerForTeamData } from '@protocol/chat'
import { MATCH_GAME_STATUS } from 'adv-protocol/src/GameCommon'
import { MatchRecordSimpleMatchInfo } from '@views/MatchRecord'

export default class ConvertUtils {
  static converterMatchTrackToUserPickMatch(params: {
    tournamentTrack: Schema$TournamentTrack
    matchTrack: Schema$MatchTrack
  }): Schema$UserPickMatch {
    const { tournamentTrack, matchTrack } = params
    const {
      sportId, sportName, categoryId, categoryName,
      tournamentId, tournamentName, tournamentEmblem,
    } = tournamentTrack
    const {
      matchId, homeTeamName, homeTeamEmblem, homeScore,
      awayTeamName, awayTeamEmblem, awayScore, dateOfMatch, isFavorite,
      matchStatusCode, statusCode,
    } = matchTrack
    return {
      matchId,
      sportId,
      categoryId,
      tournamentId,
      sportName,
      categoryName,
      tournamentName,
      tournamentEmblem,
      homeTeamName,
      homeTeamEmblem,
      homeTeamScore: homeScore,
      awayTeamName,
      awayTeamEmblem,
      awayTeamScore: awayScore,
      dateOfMatch,
      // 내가 찜한 매치 여부
      isFavoriteMatch: isFavorite,
      matchStatus: matchStatusCode,
      status: statusCode,
    }
  }

  static converterCheerForTeamDataToMatchRecordSimpleMatchInfo(params: {
    cheerForTeamData: Schema$CheerForTeamData
  }): MatchRecordSimpleMatchInfo {
    const { cheerForTeamData } = params
    const {
      matchId,
      sportId,
      homeScore,
      awayScore,
      homeName,
      awayName,
      homeEmblem,
      awayEmblem,
      matchStatusName,
      status,
    } = cheerForTeamData
    return {
      matchId,
      sportId,
      homeScore,
      awayScore,
      homeTeamName: homeName,
      awayTeamName: awayName,
      homeTeamEmblem: homeEmblem,
      awayTeamEmblem: awayEmblem,
      matchStatusName,
      isLiveMatch: status === MATCH_GAME_STATUS.Live,
    }
  }
}
